var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.community.customSettings
      ? _c("div", { staticClass: "box" }, [
          _c(
            "fieldset",
            [
              _c("legend", [_vm._v("Details")]),
              _vm._v(" "),
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", [_vm._v("Community:")]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: { name: "community name" },
                    on: { input: _vm.sanitizeName },
                    model: {
                      value: _vm.community.name,
                      callback: function($$v) {
                        _vm.$set(_vm.community, "name", $$v)
                      },
                      expression: "community.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("community name"),
                      expression: "errors.has('community name')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("community name")))]
              ),
              _vm._v(" "),
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", [_vm._v("Code:")]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: { name: "community code" },
                    on: { input: _vm.sanitizeCode },
                    model: {
                      value: _vm.community.code,
                      callback: function($$v) {
                        _vm.$set(_vm.community, "code", $$v)
                      },
                      expression: "community.code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("community code"),
                      expression: "errors.has('community code')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("community code")))]
              ),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Logo URL:")]),
                  _vm._v(" "),
                  _c("md-input", {
                    on: { input: _vm.sanitizeLogoUrl },
                    model: {
                      value: _vm.community.customSettings.logoURL,
                      callback: function($$v) {
                        _vm.$set(_vm.community.customSettings, "logoURL", $$v)
                      },
                      expression: "community.customSettings.logoURL"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Background Color:")]),
                  _vm._v(" "),
                  _c("md-input", {
                    on: { input: _vm.sanitizeColor },
                    model: {
                      value: _vm.community.customSettings.primaryColor,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.community.customSettings,
                          "primaryColor",
                          $$v
                        )
                      },
                      expression: "community.customSettings.primaryColor"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Text Color:")]),
                  _vm._v(" "),
                  _c("md-input", {
                    on: { input: _vm.sanitizeColor },
                    model: {
                      value: _vm.community.customSettings.secondaryColor,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.community.customSettings,
                          "secondaryColor",
                          $$v
                        )
                      },
                      expression: "community.customSettings.secondaryColor"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.saveText))]
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37fc65cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fc65cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCommunity.vue
// module id = null
// module chunks = 